export default {
  banner: {
    title: "Authing Partner Network",
    subtitle:
      "We have found a way to help enterprise administrators and developers to complete application single sign-on more simply and efficiently.",
    intro: "Learn more",
    get: "Learn more",
    card1: {
      name: "Lark",
      descript:
        "Lark integrates functions such as instant communication, calendar, online documents, cloud disk, application center, etc., to provide a high-quality cloud collaboration experience, achieve organizations and individuals.",
    },
    card2: {
      name: "AWS China",
      descript:
        "Amazon Web Services offers reliable, scalable, and inexpensive cloud computing services. Free to join, pay only for what you use.",
    },
    card3: {
      name: "Alibaba Cloud",
      descript:
        "Alibaba Cloud is one of the world's largest cloud computing companies, providing scalable, secure, and reliable cloud computing services globally to accelerate digitalization.",
    },
    card4: {
      name: "Huawei Cloud",
      descript:
        "Huawei Cloud provides users with cloud servers, cloud databases, cloud storage, CDN, big data, cloud security and other public cloud products, as well as e-commerce, finance, and gaming solutions.",
    },
  },

  recommend: {
    title: "Recommended Applications",
    get: "Learn more",
    item1: {
      name: "Lark",
      descript:
        "Lark integrates functions such as instant communication, calendar, online documents, cloud disk, application center, etc., to provide a high-quality cloud collaboration experience, achieve organizations and individuals.",
    },
    item2: {
      name: "GitLab",
      descript:
        "Gitlab's open DevOps platform is a single application with unparalleled collaboration, visibility and development speed.",
    },
    item3: {
      name: "Zabbix",
      descript:
        "Zabbix is a mature and easy-to-use enterprise-level open source monitoring solution suitable for network monitoring and application monitoring with millions of indicators.",
    },
    item4: {
      name: "Huawei Cloud",
      descript:
        "Huawei Cloud provides users with cloud servers, cloud databases, cloud storage, CDN, big data, cloud security and other public cloud products, as well as e-commerce, finance, and gaming solutions.",
    },
    item5: {
      name: "Alibaba Cloud",
      descript:
        "Alibaba Cloud provides free trials, cloud servers, cloud databases, cloud security, cloud enterprise applications and other cloud computing services, as well as big data, artificial intelligence services, and precise customization of industry solutions based on scenarios.",
    },
    item6: {
      name: "Tencent Enterprise E-mail",
      descript:
        "Tencent Enterprise E-mail is a set of office mail system tailored for enterprises. We provide developers with five open interfaces: address book management, new email reminder, single sign-on, system log, and function settings.",
    },
    item7: {
      name: "AWS China",
      descript:
        "Amazon Cloud Technology provides a complete set of infrastructure and cloud solutions for global customers. Safe and reliable cloud computing services based on elastic cloud servers, cloud storage, databases, and machine learning help companies easily go to the cloud.",
    },
    item8: {
      name: "ServiceDesk Plus",
      descript:
        "ServiceDesk Plus transforms the IT team from daily firefighting to providing excellent customer service. It provides good visibility and central control when dealing with IT issues to ensure that there is no downtime in the business.",
    },
    item9: {
      name: "Tencent Cloud",
      descript:
        "Tencent Cloud provides secure and stable cloud computing services for millions of enterprises and developers, covering cloud servers, cloud databases, cloud storage, video and CDN, domain name registration and other comprehensive cloud services and solutions for various industries.",
    },
    item10: {
      name: "ServiceDesk Plus China",
      descript:
        "ServiceDesk Plus transforms the IT team from daily firefighting to providing excellent customer service. It provides good visibility and central control when dealing with IT issues to ensure that there is no downtime in the business.",
    },
  },
  createApp: {
    title: "Can't find what you need?",
    subtitle:
      "You can submit the application information you need in the Authing forum",
    button: "Request integration",
  },
  apnDoc: {
    title: "Join the Authing Partner Network?",
    subtitle:
      "You can add your app to the Authing Partner Network, allowing millions of customers to quickly integrate access",
    button: "Learn more",
  },
  detailApp: {
    "btn-goback": "Return",
    "btn-getapp": "Get",
    "label-category": "Classification：",
    "label-developer": "Developer：",
    "label-developer-company": "Steamory",
    "label-ability": "Ability：",
    "label-protocol": "Protocol",
    "title-intro": "Introduction",
    "title-link": "Application Site",
    "title-overview": "Preview",
    "label-info": "Information",
    subtitle: "Single sign-on integration",
    forward: "Coming soon",
    esign: {
      title: "eSign",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "eSign is a leader in China's Internet electronic signature industry. It is committed to providing customers with legally effective electronic contract full life cycle services, reducing the document signing process that would otherwise take several days to just tens of seconds.",
    },
    zoom: {
      title: "Zoom",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Zoom is the leader in modern enterprise video communications, with an easy, reliable cloud platform for video and audio conferencing, chat, and webinars across mobile, desktop, and room systems. Zoom Rooms is the original software-based conference room solution used around the world in board, conference, huddle, and training rooms, as well as executive offices and classrooms. Founded in 2011, Zoom helps businesses and organizations bring their teams together in a frictionless environment to get more done. Zoom is a publicly traded company headquartered in San Jose, CA.",
    },
    google: {
      title: "Google Workspace",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Google Workspace | Business Apps & Collaboration Tools，Try Google Workspace's (formerly G Suite) secure collaboration and productivity apps for businesses of all sizes. Includes Gmail, Drive, Meet and more.",
    },
    github: {
      title: "Github Enterprise",
      tag: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "Github Enterprise is a unified product for Enterprise Cloud and Enterprise Server, allowing organizations to configure their own cloud-based or self-built GitHub. Through GitHub Connect, these products can be connected to each other and provide hybrid options, and developers can work seamlessly.",
    },
    jira: {
      title: "Jira",
      tag: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "Plan, track, and manage your agile and software development projects in Jira. Customize your workflow, collaborate, and release great software.",
    },
    confluence: {
      title: "Confluence",
      tag: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "Confluence is a team workspace where knowledge and collaboration meet. Trusted for documentation, decisions, project collaboration & Jira integrations.",
    },
    lark: {
      title: "Lark",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Lark is the next-gen workspace for teams. The future of work is here, and it is free. ",
    },
    gitlab: {
      title: "GitLab",
      tag: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "Iterate faster, innovate together: Our open DevOps platform is a single application for unparalleled collaboration, visibility, and development velocity.",
    },
    zabbix: {
      title: "Zabbix",
      tag: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "Zabbix is a mature and effortless enterprise-class open source monitoring solution for network monitoring and application monitoring of millions of metrics.",
    },
    huaweicloud: {
      title: "HUAWEI Cloud",
      tag: "Cloud Computing",
      subtitle: "Single sign-on integration",
      intro:
        "HUAWEI Cloud - All the tech, cloud services and support you need to smooth out your journey to the cloud.",
    },
    alicloud: {
      title: "Alibaba Cloud",
      tag: "Cloud Computing",
      subtitle: "Single sign-on integration",
      intro:
        "Alibaba Cloud is one of the world's largest cloud computing companies, providing scalable, secure, and reliable cloud computing services globally to accelerate digitalization empowered by comprehensive cloud products and solutions.",
    },
    exmail: {
      title: "EXMAIL",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Tencent Exmail box, the only enterprise mailbox that can send and receive emails in WeChat. Purchase a paid version of corporate email and give away a domain name for free. Each account starts at 100 yuan per year, with multiple discounts, and a limited-time free trial for corporate mailboxes.",
    },
    aws: {
      title: "AWS China",
      tag: "Cloud Computing",
      subtitle: "Single sign-on integration",
      intro:
        "Amazon Web Services offers reliable, scalable, and inexpensive cloud computing services. Free to join, pay only for what you use.",
    },
    "service-desk-plus": {
      title: "ServiceDesk Plus",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "ServiceDesk Plus is a game changer in turning IT teams from daily fire-fighting to delivering awesome customer service. It provides great visibility and central control in dealing with IT issues to ensure that businesses suffer no downtime. For 10 years and running, it has been delivering smiles to millions of IT folks, end users, and stakeholders alike.",
    },
    "tencent-cloud": {
      title: "Tencent Cloud",
      tag: "Cloud Computing",
      subtitle: "Single sign-on integration",
      intro:
        "Tencent is a leading influencer in industries such as social media, mobile payments, online video, games, music, and more. Leverage Tencent's vast ecosystem of key products across various verticals as well as its extensive expertise and networks to gain a competitive edge and make your own impact in these industries.",
    },
    "service-desk-plus-cn": {
      title: "ServiceDesk Plus China",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "ServiceDesk Plus is a game changer in turning IT teams from daily fire-fighting to delivering awesome customer service. It provides great visibility and central control in dealing with IT issues to ensure that businesses suffer no downtime. For 10 years and running, it has been delivering smiles to millions of IT folks, end users, and stakeholders alike.",
    },
    hongyi: {
      title: "MACROWING",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Shanghai Macrowing Software Technology Co., Ltd. (MACROWING®) is a top-notch service provider of ECM (Enterprise Content Management) and intelligent management of big data in China.",
    },
    gnway: {
      title: "GNWAY",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "As a trusted enterprise information Internet platform in China, GNWAY is positioned to provide information services to enterprises with management software providers in various industries. We do not produce management software, but provide pre-sales, in-sales, and after-sales Internet platforms. Services to help manage the success of software providers and their users.",
    },
    udesk: {
      title: "Udesk",
      tag: "CRM",
      subtitle: "Single sign-on integration",
      intro:
        "Udesk is a professional and leading enterprise level customer service system platform in China, with tens of thousands of enterprise users. It provides enterprises with a complete Omnichannel customer service center solution integrating online customer service system, intelligent customer service system, customer service robot, call center, work order system, big data analysis platform, intelligent knowledge base and CRM, and supports all scene intelligent customer service system office, Easy to achieve cross departmental and multi-party cooperation, enterprise services must choose customer service software, detailed hotline: 15559944612",
    },
    slack: {
      title: "Slack",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Slack is a messaging app for business that connects people to the information they need. By bringing people together to work as one unified team, Slack transforms the way organizations communicate.Slack helps you work in a more connected, flexible, and inclusive way.",
    },
    wordpress: {
      title: "WordPress",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "the world’s most popular website builder.42% of the web is built on WordPress. More bloggers, small businesses, and Fortune 500 companies use WordPress than all other options combined.",
    },
    seafile: {
      title: "Seafile",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Seafile is an open source file sync&share solution designed for high reliability, performance and productivity. Sync, share and collaborate across devices and teams. Build your team's knowledge base with Seafile's built-in Wiki feature.",
    },
    kibana: {
      title: "Kibana",
      tag: "Cloud Computing",
      subtitle: "Single sign-on integration",
      intro:
        "Kibana is a free and open user interface that lets you visualize your Elasticsearch data and navigate the Elastic Stack. Do anything from tracking query load to understanding the way requests flow through your apps.",
    },
    jenkins: {
      title: "Jenkins",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Jenkins build great things at any scale. The leading open source automation server, Jenkins provides hundreds of plugins to support building, deploying and automating any project.",
    },
    teambition: {
      title: "Teambition",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Including new-generation tools such as project space, network disk, documents, to-do, calendar, etc., to help you turn your ideas into reality and make the creative process full of joy. Created by the Alibaba Teambition team, personal use is completely free.",
    },
    salesforce: {
      title: "Salesforce",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Salesforce is a customer relationship management solution that connects companies and customers. Salesforce is an integrated CRM platform that provides a single shared view of all customers for all your departments, including marketing, sales, business and service.",
    },
    jfrog: {
      title: "JFrog",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "JFrog products seamlessly integrate with practically any development environment on Earth, from legacy code to the most recent containers and micro-services.",
    },
    zendesk: {
      title: "ZenDesk",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Zendesk has formed a set of very mature product concept and product system. Just like what Zendesk introduced, they always take customer service as the core, provide perfect solutions, powerful and simple tools, have open and flexible platform, accumulate massive data, and have reasonable pricing mode, which reduce the deployment cost of enterprises.",
    },
    fxiaoke: {
      title: "FXiaoKe",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Connected CRM system for FXiaoKe customers-to create an integrated intelligent CRM platform for marketing, sales management, channel management, service management, etc., and its own PaaS platform to meet the individual needs of medium and large enterprises, providing fast consumer goods, agriculture, animal husbandry, and manufacturing , High-tech and other industries exclusive CRM solutions.",
    },
    adobe: {
      title: "Adobe",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Adobe is changing the world through digital experiences. We help our customers create, deliver and optimize content and applications.",
    },
    expensify: {
      title: "Expensify",
      tag: "Office",
      tag2: "Finance",
      subtitle: "Single sign-on integration",
      intro:
        "Track expenses, submit expense reports, pay bills, generate invoices, collect payments, track mileage, plan trips, and get the best business credit card - all with the Expensify app!",
    },
    qingflow: {
      title: "QingFlow",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "QingFlow-a lightweight, customizable management system to build a platform, without code development, you can quickly and flexibly create your own personalized management system like building blocks, and easily realize the digital management of multiple business scenarios.-a lightweight, customizable management system to build a platform, without code development, you can quickly and flexibly create your own personalized management system like building blocks, and easily realize the digital management of multiple business scenarios.",
    },
    strapi: {
      title: "Strapi",
      tag: "Cloud Computing",
      subtitle: "Single sign-on integration",
      intro:
        "Strapi is the next-gen headless CMS, open-source, javascript, enabling content-rich experiences to be created, managed and exposed to any digital device.",
    },
    "aliyun-intel-user-sso": {
      title: "Alibaba Cloud Intel",
      tag: "Cloud Computing",
      subtitle: "Single sign-on integration",
      intro:
        "Alibaba Cloud is one of the world's largest cloud computing companies, providing scalable, secure, and reliable cloud computing services globally to accelerate digitalization empowered by comprehensive cloud products and solutions.",
    },
    "aws-en": {
      title: "AWS",
      tag: "Cloud Computing",
      subtitle: "Single sign-on integration",
      intro:
        "Amazon Web Services offers reliable, scalable, and inexpensive cloud computing services. Free to join, pay only for what you use.",
    },
    maycur: {
      title: "Maycur",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Maycur is the cloud platform of intelligent expense management of MEC technology. It is the leading SaaS platform for enterprise travel and expense management in China. It provides travel booking, expense reimbursement management and whole process expense control services for enterprises.",
    },
    discourse: {
      title: "Discourse",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Discourse is a simple, flat forum, reply is like a waterfall linear display on the page. Replies can be expanded, at the bottom or top of the post, so you know the full context of the conversation - without interrupting your reading.",
    },
    beisen: {
      title: "EXMAIL",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Beisen's integrated talent management cloud platform provides enterprises with integrated HR SaaS software and services covering the whole process of talent assessment, recruitment management, performance management, organization and personnel, salary, leave, succession, investigation, Onboarding, etc. There is a PaaS platform to meet the needs of individualized and independent development of medium and large enterprises.",
    },
    xiaoshouyi: {
      title: "Neocrm",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Neocrm provides the next generation of CRM solution leveraging mobile social platform and big data technology.",
    },
    metabase: {
      title: "Metabase",
      tag: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "The fastest, easiest way to share data and analytics inside your company. An open source Business Intelligence server you can install in 5 minutes that connects to MySQL, PostgreSQL, MongoDB and more! Anyone can use it to build charts, dashboards and nightly email reports.",
    },
    jamf: {
      title: "Jamf Pro",
      tag: "Office",
      subtitle: "Single sign-on integration",
      intro:
        "Jamf Pro is comprehensive enterprise management software for the Apple platform, simplifying IT management for Mac, iPad, iPhone and Apple TV.",
    },
    sentry: {
      title: "Sentry",
      tag: "Office",
      tag1: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "Sentry's application monitoring platform helps every developer diagnose, fix, and optimize the performance of their code.",
    },
    sonarqube: {
      title: "Sonarqube",
      tag: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "Sonarqube catch bugs and vulnerabilities in your app, with thousands of automated Static Code Analysis rules.",
    },
    bitbucket: {
      title: "Bitbucket",
      tag: "Project Management",
      subtitle: "Single sign-on integration",
      intro:
        "It is a web-based version control repository hosting service, for source code and development projects that use either Mercurial or Git revision control systems.",
    },
  },
  other: {
    "input-tip": "Please enter keywords",
    "app-null": "Sorry, there is no related content",
  },
};
